export enum ClickToPayCheckoutResponseActionCode {
    complete = 'COMPLETE',
    cancel = 'CANCEL',
    error = 'ERROR',
    changeCard = 'CHANGE_CARD',
    addCard = 'ADD_CARD',
    switchConsumer = 'SWITCH_CONSUMER'
}
